export * from 'groups/selectors/groups_selectors';



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/selectors/index.js